import dayjs from 'dayjs';
// import isEmpty from '@fund/basic-lib/dist/lib/lang/isEmpty';

import Model from 'ducker-model';

// 1. 定义 property
const property = {
  fundName: String,
  fundCode: String,
  isFloatCurrency: Boolean,
  isFixedProfit: Boolean,
  isFloatProfit: Boolean,
  isNetFixedProfit: Boolean,
  isNewFund: Boolean,
  establishDate: String,
  establishLessThanYear: Boolean,
  newHighEndHeaderInfo: Object,
  sellState: Number,
  isSales: Boolean,
  establishMoreThanThreeYear: Boolean,
};

// 2. 定义 replacedKeyFromPropertyName
const replacedKeyFromPropertyName = {
  fundName: {
    property: 'SHORTNAME',
    defaultValue: '',
  },
  fundCode: {
    property: 'FCODE',
    defaultValue: '',
  },
  isFloatCurrency: {
    property: ['FTYPE'],
    defaultValue: false,
    computed: ([fType]) => fType === '浮动货币型',
  },
  isFixedProfit: {
    property: ['FTYPE'],
    defaultValue: false,
    computed: ([fType]) => fType === '固定收益',
  },
  isFloatProfit: {
    property: ['FTYPE'],
    defaultValue: false,
    computed: ([fType]) => fType === '浮动收益',
  },
  isNetFixedProfit: {
    property: ['FTYPE'],
    defaultValue: false,
    computed: ([fType]) => fType === '净值型固收',
  },
  isNewFund: {
    property: ['ISNEW'],
    defaultValue: false,
    computed: ([isNew]) => {
      console.log('isNew====', isNew);
      return isNew === '1';
    },
  },
  establishDate: {
    property: 'ESTABDATE',
    defaultValue: '',
  },
  establishLessThanYear: {
    property: 'ESTABDATE',
    defaultValue: false,
    computed: (date) => {
      if (!date) return true;
      return dayjs().diff(dayjs(date), 'year') < 1;
    },
  },
  newHighEndHeaderInfo: {
    property: ['ISSBDATE', 'ISSEDATE'],
    defaultValue: {},
    computed: ([ISSBDATE, ISSEDATE]) => ({ startTime: ISSBDATE, endTime: ISSEDATE }),
  },
  sellState: {
    property: ['SELLSTATE2'],
    defaultValue: 0,
    computed: ([state]) => Number(state) || 0,
  },
  isSales: {
    property: 'ISSALES',
    defaultValue: false,
    computed: (value) => Number(value) === 1,
  },
  establishMoreThanThreeYear: {
    property: 'ESTABDATE',
    defaultValue: false,
    computed: (date) => dayjs().diff(dayjs(date), 'year') >= 3,
  },
};

export default new Model(property, replacedKeyFromPropertyName);
